import { FIR_AUTOFILL_DATA, CORPORATE_AUTOFILL_DATA} from "./type";

const initalState = {
  firData: {},
  corporateAutofill: {},
};

const firAutofillData = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case FIR_AUTOFILL_DATA:
      return {
        ...state,
        firData: payload,
      }
    case CORPORATE_AUTOFILL_DATA:
      return {
        ...state,
        corporateAutofill: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default firAutofillData;
